// extracted by css-extract-rspack-plugin
export default {"breadcrumbs":"wAko_"};